
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#fff","viewBox":"0 0 30 29"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('path',{attrs:{"d":"M14.656 12.715c.035.07.078.133.137.191l1.906 1.785c.016.02.035.036.055.051.035.07.078.133.137.192l1.906 1.785c.05.05.11.097.172.129L14.23 21.43a1.348 1.348 0 01-1.859 0l-1.133-1.094a.432.432 0 01-.129-.305c0-.113.047-.222.13-.304.437-.442.429-1.141-.016-1.575a1.19 1.19 0 00-1.63-.015.463.463 0 01-.628 0l-1.133-1.094a1.248 1.248 0 010-1.8l4.723-4.563c.035.07.078.136.14.199l1.907 1.785c.015.02.035.035.054.05zm1.11-.89a.674.674 0 00-.141-.192l-1.902-1.785a.638.638 0 00-.176-.13l2.223-2.144a1.34 1.34 0 011.859 0l1.133 1.09a.425.425 0 010 .61 1.093 1.093 0 000 1.59 1.187 1.187 0 001.644 0 .463.463 0 01.63 0l1.132 1.093a1.248 1.248 0 010 1.8l-2.207 2.13a.71.71 0 00-.14-.2l-1.903-1.785c-.02-.015-.035-.035-.055-.05a.674.674 0 00-.14-.192l-1.903-1.785a.698.698 0 01-.054-.05zM15 .71c7.879 0 14.266 6.172 14.266 13.789S22.879 28.29 15 28.29C7.121 28.29.734 22.116.734 14.5.734 6.883 7.121.71 15 .71zm0 1.621c-6.953 0-12.59 5.45-12.59 12.168 0 6.719 5.64 12.168 12.59 12.168s12.59-5.45 12.59-12.168c0-6.719-5.64-12.168-12.59-12.168zm0 0"}})])
          )
        }
      }
    